module.exports = __webpack_public_path__ + "img/book-reader.f684326a.svg";